import React from 'react';

export const mailToPrinter = () => {
  return function MailToPrinter({ item, itemKey }) {
    return <a href={`mailto:${item[itemKey]}`}>{item[itemKey]}</a>;
  };
};
